export const BASE_URL = process.env.REACT_APP_BASE_URL;
// export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://base-staging.olhso.com";
// export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://base-dev.olhso.com";

// export const BASE_URL = "https://base-staging.olhso.com";
// export const BASE_URL = "https://base.olhso.com";
